import React, { createContext, useContext, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const PresenceContext = createContext();

export const PresenceProvider = ({ children }) => {
  const location = useLocation();
  const [currentPagePath, setCurrentPagePath] = useState(location.pathname);
  const [currentEntity, setCurrentEntity] = useState({
    entityType: null,
    entityId: null,
  });

  useEffect(() => {
    setCurrentPagePath(location.pathname);
  }, [location.pathname]);

  return (
    <PresenceContext.Provider
      value={{ currentPagePath, currentEntity, setCurrentEntity }}
    >
      {children}
    </PresenceContext.Provider>
  );
};

export const usePresence = () => {
  const context = useContext(PresenceContext);
  if (!context) {
    throw new Error("usePresence must be used within a PresenceProvider");
  }
  return context;
};
